import React, { Component } from 'react'
import VariationsSelector from '../../Global_Layouts/VariationsSelector/VariationsSelector'
import Product_imgs from '../../Layouts/Layouts_product/Product_imgs/Product_imgs'
import { storeData } from '../../storeData'
import numeral from 'numeral';
import './UpsellPage.css'
import CounterDown from '../../Global_Layouts/CounterDown/CounterDown';
import Loader from '../../Global_Layouts/Loader/Loader';


export default class UpsellPage extends Component {

  state = {
    ProductData: this.props.product_data_for_upsell,
    selectedPackData: {units: [0]},
    // upsellItem: {unitary_price: (this.props.product_data_for_upsell.comodin_price - storeData().products[0].upsellDiscount), quantity: 1},
    upsellItem: {unitary_price: (this.props.product_data_for_upsell.comodin_price - this.props.store_product_data.upsellDiscount), quantity: 1},
    selectedVariants: [],
  }

  componentDidMount=()=>{
    //1. Inicializa "selectedVariants" con los valores de index "0" de cada opcion de variante
    const modalContainer = document.querySelector('.pure-modal .panel-body');
    modalContainer.scrollTop = 0;
    const {selectedPackData} = this.state;
    this.initializedSelectedVariantsArrayFunction(selectedPackData);
  }

  initializedSelectedVariantsArrayFunction = (selectedPackData) => {
    const {ProductData} = this.state
    let initializedSelectedVariantsArray = []

    if(ProductData.productWithVariations==="SI"){
      ProductData.productOptions.map((variantData, index) => {
        selectedPackData.units.map(unit=>{
          let varData = this.getSelectedVariants({variant: variantData.values[0], value: "0"}, unit, index, true)

          initializedSelectedVariantsArray[unit] = {
            ...initializedSelectedVariantsArray[unit],
            [varData.variant_key]: varData.variant_key_value,
            sku: varData.sku,
            variant_title: varData.variant_title,
            variation_index_calculated: varData.variation_index_calculated,
            variation_index_from_product_data: varData.variation_index_from_product_data,
          }
        })
      })
    }

    this.setState({
      selectedVariants: initializedSelectedVariantsArray
    })

  }

  getSelectedVariants = (e, unit, index, isInitialized, value) => {
    const {ProductData} = this.state
    //MODEL: selectedVariants: [{variant0:"", variant1:""},{variant0:"", variant1:""},{variant0:"", variant1:""}],
    //2. Actualiza el valor de la variante del "index" para la unidad "unit"
    let newSelectedVariantObj = {
      ...this.state.selectedVariants[unit],
      variant_key: "variant"+index.toString(),
      ["variant"+index]: isInitialized===true? e.variant : value!==undefined && value!==null && value!==""? value.split("@")[0] : e.target.value.split("@")[0],
      ["option"+index]: index.toString(),
      ["value"+index]: isInitialized===true? e.value : value!==undefined && value!==null && value!==""? value.split("@")[1] : e.target.value.split("@")[1]
    }

    //2.1. Obtiene "sku" y "variation_title" con base en "option"+index" y ""value"+index" y "productOptions.length"
    let variation_index = ""
    for (let i = 0; i < ProductData.productOptions.length; i++) {
      let OP = newSelectedVariantObj["option"+i]!==undefined? newSelectedVariantObj["option"+i] : i
      let V = newSelectedVariantObj["value"+i]!==undefined? newSelectedVariantObj["value"+i] : "0"
      let content_to_add = "OP"+OP+"-"+"V"+V
      variation_index = variation_index + (i===0? content_to_add : ("/" + content_to_add))
    }
    let variationData = ProductData.productVariations.filter( variationData => variationData.variation_index === variation_index)[0]
    newSelectedVariantObj.sku = variationData.variation_sku
    newSelectedVariantObj.variant_title = variationData.variation_title
    newSelectedVariantObj.variation_index_calculated = variation_index
    newSelectedVariantObj.variation_index_from_product_data = variationData.variation_index
    newSelectedVariantObj.img_src = variationData.variation_img_src

    //3. Actualiza las variantes de la unidad "unit"
    if(isInitialized===true){
      return {
        variant_key: newSelectedVariantObj.variant_key,
        variant_key_value: newSelectedVariantObj[newSelectedVariantObj.variant_key],
        sku: newSelectedVariantObj.sku,
        variant_title: newSelectedVariantObj.variant_title,
        variation_index_calculated: newSelectedVariantObj.variation_index_calculated,
        variation_index_from_product_data: newSelectedVariantObj.variation_index_from_product_data,
      }
    } else {
      let newSelectedVariantsArray = [...this.state.selectedVariants]
      newSelectedVariantsArray[unit] = newSelectedVariantObj
      this.setState({
        selectedVariants: newSelectedVariantsArray
      })
    }
  }

  render() {
    const {showLoader, createOrderWithUpsell, declineUpsell,  first_name} = this.props
    const {ProductData, selectedVariants, upsellItem} = this.state
    if(showLoader===false){
      return (
        <div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-lg-6">
                <div className='ThankYouPage_header'>
                  <div className='UpsellPage_title'> ¡{first_name} Gracias por tu compra!</div>
                  <div className='UpsellPage_alert d-flex align-items-center'>
                    <div style={{fontSize:"45px"}}>🎁</div>
                    <div className='UpsellPage_text'>{this.props.store_product_data.upsellCopy_header_main} <span>{this.props.store_product_data.upsellCopy_header_secondary}</span></div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-6">
                <div className='UpsellPage_subtext'><strong>Oferta por tiempo limitado</strong></div>
                <div className='UpsellPage_subtext'> <strong>Lleva 1 por</strong> <span className='UpsellPage_subtext_price'>{numeral(ProductData.comodin_price - this.props.store_product_data.upsellDiscount).format('$ 0,0[.]00')}</span> <strong>y ahorra</strong> <span className='UpsellPage_subtext_discount'>{numeral(this.props.store_product_data.upsellDiscount).format('$ 0,0[.]00')}.</span></div>  
                <CounterDown hours={this.props.store_product_data.upsell_counter_hours} minutes={this.props.store_product_data.upsell_counter_minutes} seconds={this.props.store_product_data.upsell_counter_seconds}  />
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-lg-6">
                <div className='UpsellPage_imgs'>
                  <Product_imgs fromUpsell={true} ProductData={ProductData} shoppingMoreThanOne={false} selectedVariants={selectedVariants}/>
                </div>
              </div>
              <div className="col-md-12 col-lg-6">
              <div className="Product_data_separator"></div>
                <div className='Product_data_prices'>
                    <div className='Product_data_price'>{numeral(ProductData.comodin_price - this.props.store_product_data.upsellDiscount).format('$ 0,0[.]00')}</div>
                    <div className='Product_data_comparative_price'>{numeral(ProductData.comodin_price).format('$ 0,0[.]00')}</div>
                </div>
                <div className='Product_data_discount'>AHORRAS {numeral(this.props.store_product_data.upsellDiscount).format('$ 0,0[.]00')} </div>
                <VariationsSelector getSelectedVariants={this.getSelectedVariants} selectedVariants={selectedVariants} ProductData={ProductData}/>
                
                <div style={{marginBottom:"350px"}}></div>

                <div className='sticky-footer'>
                  <div className='UpsellPage_btn_container'>
                    <button className='UpsellPage_btn_accept' onClick={(e)=>createOrderWithUpsell(e, ProductData, upsellItem, selectedVariants)}>ACEPTAR OFERTA</button>
                    <button className='UpsellPage_btn_cancel' onClick={(e)=>declineUpsell(e)}>RECHAZAR OFERTA</button>
                  </div>
                </div>
              
              </div>
            </div>
          </div>

        </div>
      )
    }

    return (<Loader first_name={first_name} statusLabel={ "Actualizando" }/>)
  }
}
